import * as React from 'react';
const SvgEmoticonNeutral = (props) => (
   <svg xmlns="http://www.w3.org/2000/svg" width={56} height={56} {...props}>
      <g fill={props.fill ? props.fill : '#4A4A4A'} fillRule="evenodd">
         <path d="M22.5 21c1.38 0 2.5 1.343 2.5 3s-1.12 3-2.5 3-2.5-1.343-2.5-3 1.12-3 2.5-3M33.5 21c1.38 0 2.5 1.343 2.5 3s-1.12 3-2.5 3-2.5-1.343-2.5-3 1.12-3 2.5-3M21 34h14v-2H21z" />
         <path
            fillRule="nonzero"
            d="M28 8c11.03 0 20 8.971 20 20s-8.97 20-20 20S8 39.03 8 28 16.97 8 28 8m0 3.077c-9.33 0-16.923 7.593-16.923 16.923S18.67 44.923 28 44.923 44.923 37.33 44.923 28 37.33 11.077 28 11.077"
         />
      </g>
   </svg>
);
export default SvgEmoticonNeutral;
